<script>
import axios from 'axios'
import { appMethods } from '@state/helpers'

export default {
  data: () => ({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    loading: false,
  }),
  methods: {
    ...appMethods,
    submit() {
      this.loading = true
      axios
        .post('/api/v2/change_password', {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        })
        .then(() => {
          this.loading = false
          this.showAlert({ message: 'Your password was updated successfuly.' })
        })
        .catch(({ response }) => {
          this.loading = false
          let message = 'Failed to update your password.'
          if (response && response.status === 400)
            message = response.data.message
          this.showAlert({ type: 'error', message })
        })
    },
  },
}
</script>

<template>
  <div class="border border-gray-500 rounded-sm h-full bg-gray-100">
    <div class="py-4 px-3 bg-white">
      <h4 class="font-medium">Change Password</h4>
    </div>
    <div class="flex flex-wrap pt-6">
      <div class="w-full">
        <ValidationObserver v-slot="{ invalid, passes }" slim>
          <form @submit.prevent="passes(submit)">
            <BaseInput
              v-model="currentPassword"
              type="password"
              label="Current Password"
              rules="required|min:8"
            />
            <BaseInput
              v-model="newPassword"
              type="password"
              label="New Password"
              rules="required|min:8"
            />
            <BaseInput
              v-model="confirmPassword"
              type="password"
              label="Confirm New Password"
              rules="required|confirmed:newPassword"
            />
            <div class="w-full mb-6 px-3 text-right">
              <button
                type="submit"
                class="btn btn-gold"
                :class="{ 'btn-disabled': invalid || loading }"
                :disabled="invalid || loading"
                @click="submit"
              >
                <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-else>Change Password</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
